const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem("token");
const authorizationToken = token?.trim().replace(/^(?:Bearer\s+)+/i, "");

export default async function commonapihandler(url, method, body) {
  const requestHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(authorizationToken && {
      Authorization: `Bearer ${authorizationToken}`,
    }),
  };

  const requestBody = JSON.stringify(body);

  const apiResponse = {
    method,
    headers: requestHeaders,
    ...(body && method !== "GET" && method !== "HEAD" && { body: requestBody }),
  };

  try {
    const response = await fetch(`${BASE_URL}${url}`, apiResponse);
    
    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching ${url}:`, error);
    return null;
  }
}
